/** CSS classes for exercise answer buttons — see exercise-theme.css */
export const XQ_EXERCISE_ANSWER = "xq-exercise-answer";
export const XQ_EXERCISE_ANSWER_ON_ACCENT = "xq-exercise-answer--on-accent";

export function exerciseAnswerFeedbackClass(
  state: "correct" | "wrong" | "picked" | null,
): string {
  if (!state) {
    return "";
  }
  return `xq-exercise-answer--${state}`;
}
